/**
 * B.H. Copyright (c) 2026 Yemot HaMashiach Ltd.
 * All Rights Reserved.
 *
 * This software is the confidential and proprietary information of
 * Yemot HaMashiach Ltd. ("Confidential Information"). You shall not
 * disclose such Confidential Information and shall use it only in
 * accordance with the terms of the license agreement you entered into
 * with Yemot HaMashiach Ltd.
 *
 * Unauthorized copying of this file, via any medium, is strictly prohibited.
 */
import axios from "axios";

/**
 * **תשובת חריגה של ה-SSO היא תשובה, ולא תקלת רשת.**
 *
 * ה-SSO מוסר את הסירוב בגוף - `responseStatus: "Exception"` ו-`message` עם הקוד -
 * ונושא לצדו סטטוס שמתאים לו: `401` לסשן שמת, `403` לחשבון שחסום עד להשלמת שלב.
 * `axios` דוחה כל סטטוס שאינו 2xx, ולכן בלי המתאם הזה כל מסך כאן היה נופל ל-`catch`
 * הכללי שלו ומציג "תקלה בתקשורת" - במקום את הסיבה שהשרת מסר במפורש.
 *
 * ⚠️ **ההמרה צרה בכוונה**: רק תשובה שנושאת את מעטפת החריגה של ה-SSO חוזרת למסלול
 * הרגיל. כישלון רשת, שגיאת שרת בלי גוף, ותשובה של שירות אחר - כולם ממשיכים להידחות,
 * וה-`catch` של המסך עדיין מטפל בהם.
 *
 * מותקן פעם אחת ב-`index.js`, לצד שאר המתאמים.
 *
 * 📄 WorkFolders/dev-env-shoffice/docs/session-codes.md
 */
export function installSsoExceptionAdapter(client = axios) {
  client.interceptors.response.use(
    (response) => response,
    (error) => {
      const response = error?.response;
      if (response?.data?.responseStatus === "Exception") {
        return Promise.resolve(response);
      }
      return Promise.reject(error);
    },
  );
}
